/** Pakistan / US labels as stored on country fields in this app */
const PAKISTAN = 'Pakistan'
const UNITED_STATES = 'United States of America'

function norm(value) {
    if (value == null) return ''
    return String(value).trim()
}

function countryDropdownValues(form) {
    const f = form.fatcaInfo || {}
    const b = form.basicInfo || {}
    const values = [
        b.countryOfResidence,
        f.countryOfResidence,
        f.CountryResidentTitle,
        f.CountryTaxTitle,
        f.dualNationalCountryTitle,
    ]
    return values
}
function isUnitedStates(name) {
    return norm(name) === UNITED_STATES
}

export function registrationW9WatchKey(form) {
    const f = form.fatcaInfo || {}
    const b = form.basicInfo || {}
    return [
        f.isUSCitizen,
        f.isUSResident,
        f.greenCardUS,
        b.countryOfResidence,
        f.countryOfResidence,
        f.CountryResidentTitle,
        f.CountryTaxTitle,
        f.dualNationalCountryTitle,
    ].join('|')
}
export function registrationRequiresW9(form) {
    const f = form.fatcaInfo || {}
    console.log('f', f)
    console.log('f.isUSCitizen', f.isUSCitizen)
    console.log('f.isUSResident', f.isUSResident)
    console.log('f.greenCardUS', f.greenCardUS)
    console.log('countryDropdownValues(form)', countryDropdownValues(form))
    console.log('countryDropdownValues(form).some((name) => isUnitedStates(name))', countryDropdownValues(form).some((name) => isUnitedStates(name)))
    if (
        f.isUSCitizen === 'Yes' ||
        f.isUSResident === 'Yes' ||
        f.greenCardUS === 'Yes' ||
        countryDropdownValues(form).some((name) => isUnitedStates(name))
    ) {
        return true
    }

    return false
}


function isPakistanLike(name) {
    const n = norm(name).toLowerCase()
    if (!n.length) return false
    return n === PAKISTAN.toLowerCase() || n.includes('pakistan')
}


/**
 * Every filled country field is Pakistan — no W-9, no CRS.
 */
function isPakistanOnlyCountrySelection(form) {
    const filled = countryDropdownValues(form)
        .map(norm)
        .filter((n) => n.length > 0)
    if (!filled.length) {
        return false
    }
    return filled.every((n) => isPakistanLike(n))
}

/**
 * W-9: US citizen / resident / green card Yes, or any relevant country is the US.
 * Suppressed when all filled countries are Pakistan.
 */


/**
 * CRS: only when Country of Residence (as per identity card) — basicInfo.countryOfResidence —
 * is set and is neither Pakistan nor the United States. Independent of W-9 (both may apply,
 * e.g. resident of a CRS country who is also a US person).
 */
export function registrationRequiresCrs(form) {
    const residence = norm((form.basicInfo || {}).countryOfResidence)
    if (!residence.length) {
        return false
    }

    return !isPakistanLike(residence) && !isUnitedStates(residence)
}


/**
 * Watched separately on KYC so dual country changes refresh layout without over-broad keys.
 */
export function registrationDualNationalCrsKey(form) {
    const f = form.fatcaInfo || {}
    return norm(f.dualNationalCountryTitle)
}

export function registrationCrsWatchKey(form) {
    const f = form.fatcaInfo || {}
    const b = form.basicInfo || {}
    return [
        f.isUSCitizen,
        f.isUSResident,
        f.greenCardUS,
        b.countryOfResidence,
    ].join('|')
}
